import { render, staticRenderFns } from "./EditEventSpeakersModal.vue?vue&type=template&id=5a47871a&"
import script from "./EditEventSpeakersModal.vue?vue&type=script&lang=ts&"
export * from "./EditEventSpeakersModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports